const routes = [
  {
    path: "/",
    component: () => import("@/pages/IntroMain.vue"),
  },
  {
    path: "/morning/",
    name: "morning",
    component: () => import("@/pages/morning/morning.vue"),
    pathToRegexpOptions: { strict: true },
  },
  {
    path: "/vinder/",
    name: "vinder",
    component: () => import("@/pages/vinder/main.vue"),
    pathToRegexpOptions: { strict: true },
  },
  {
    path: "/vrctorage/",
    name: "vrctorage",
    component: () => import("@/pages/vrctorage/main.vue"),
  },
  {
    path: "/nixterminal/",
    beforeEnter(to, from, next) {
      window.location.replace("https://terminal.blonix.dev");
    },
  },
  // {
  //   path: "/vinder/admin/",
  //   name: "vinder_admin",
  //   component: () => import("@/pages/vinder/admin.vue"),
  // },
  //{
  //  path: "/agentblue/",
  //  component: LayoutAgentBlue,
  //  redirect: "/agentblue/introduction",
  //  children: [
  //    {
  //      path: "introduction/",
  //      name: "ab_introduction",
  //      component: ABIntro
  //    },
  //  ]
  //},
  {
    path: "/:catchAll(.*)",
    name: "NotFound",
    component: () => import("@/pages/NotFoundPage.vue"),
  },
];

export default routes;
